import(/* webpackMode: "eager" */ "/home/runner/work/tosize-frontend/tosize-frontend/apps/frontend/src/app/not-found.tsx");
